import { Component, OnInit, Inject } from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { InventoryService } from './inventory.service';
import { NotifyService } from '../shared/services/notify.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';

declare var moment:any;

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})

export class OrderComponent implements OnInit {

  iForm: any;
  materials: any[] = [];
  suppliers: any[] = [];
  jobs: any[] = [];
  locations: any[] = [];
  inventoryTypes:string[] = [];
  slabTypes:string[] = [];
  colors:any[] = [];
  finishes:string[] = [];
  thicks:number[] = [];
  builder: FormBuilder;
  materialsArr:any[] = [];
  colorsArr:any[] = [];
  totalsArr:any[] = [];

  constructor(
    @Inject(FormBuilder) fb: FormBuilder,
    private _appService: AppService,
    private _invService: InventoryService,
    private _notifyService: NotifyService
  ) {
    this.builder = fb;
    this.iForm = this.builder.group({
      location: ["ORDERED", Validators.required],
      slabType: ["Full", Validators.required],
      inventoryType: ["For a Job", Validators.required],
      customerCompany: [null],
      jobName: [null],
      jobNum: [null],
      poNum: [null],
      supplier: [null],
      needed: [null],
      eDelivery: [null],
      shipping:[0, Validators.required],
      materials: this.builder.array([

      ])
    });

    this._appService.invSelectedPrinter$.subscribe(
      data => {
        if (this._appService.getPrintFor() == 'order') {
          this.addInventoryFinal(data)
        }
      }
    );

  }

  private getMat() {

    this.materialsArr.push(this.materials.slice(0));
    this.colorsArr.push([]);
    this.totalsArr.push({
      sub:0,
      tax:0,
      tot:0
    });



    return this.builder.group({
      material: [null, Validators.required],
      color: [null, Validators.required],
      finish: [null],
      lot: [null],
      length: [0, Validators.required],
      thickness: [0, Validators.required],
      width: [0, Validators.required],
      slabCount: [1, Validators.required],
      slabPrice: [0, Validators.required]
    });
  }

  ngOnInit() {

    this.inventoryTypes = this._invService.getInventoryTypes();
    this.slabTypes = this._invService.getSlabTypes();
    this.finishes = this._invService.getFinishes();
    this.thicks = this._invService.getThicks();

    this._invService.getLists().subscribe(
      data => {
        this.jobs = data.lists.jobNames;
        this.suppliers = data.lists.suppliers;
        this.materials = data.lists.materials;
        this.locations = data.lists.locations;
        //this.materials.unshift({name:null, colors:[]});

        setTimeout(() => {
          this.iForm.get('location').setValue('ORDERED');
          this.iForm.get('slabType').setValue('Full');
          this.iForm.get('inventoryType').setValue('For a Job');

          const control = <FormArray>this.iForm.controls['materials'];
          control.push(this.getMat());

        }, 500);


      }
    );


  }

  addInventory() {
    this._appService.showPrintSelection("order");
  }

  addInventoryFinal(printer) {

    this._appService.showLoader();

      this._invService.order(this.iForm.value).subscribe(
        data => {


          //this._invService.setOrderShow(false);
          data.inventory.originals.forEach( (item) => {
            this._invService.addRow(item);
          });
          data.inventory.children.forEach( (item) => {
            this._invService.addRow(item);
          });
          this._notifyService.setNote({
            styleClass: 'alert-success',
            heading: 'Success!',
            body: 'PO items have been saved'
          });
          this._notifyService.setNote({
            styleClass: 'alert-info',
            heading: 'EXCEL',
            body: 'Creating Excel'
          });
          this._notifyService.setNote({
            styleClass: 'alert-info',
            heading: 'PRINTING',
            body: 'Printing Labels'
          });
          this._invService.saveAndPrint(data, printer).subscribe(
            data => {
              window.open(data.url);
              this._appService.hideLoader();
              this.iForm.reset();
            }
          );
        },
        error => {
          alert('error');
          this._appService.hideLoader();
          this._notifyService.setNote({
            styleClass: 'alert-danger',
            heading: 'Oops!',
            body: 'We were not able to save that PO.'
          });
        }
      );

  }

  private saveAndPrint(data, printer) {
    this._invService.saveAndPrint(data, printer).subscribe(
      data => {
        this._appService.hideLoader();
      }
    );
  }

  hideAdd() {
    this.iForm.reset();
    this._invService.setOrderShow(false);
  }

  searchJobName = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.jobs.filter(job => new RegExp(term, 'gi').test(job)).splice(0, 10));


  searchSuppliers = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.suppliers.filter(sup => new RegExp(term, 'gi').test(sup.name)).splice(0, 10));


  setColors(m) {
    const control:any = this.iForm.controls['materials'];
    var mat:any = control.controls[m].controls.material.value;
    for(let i = 0; i< this.materialsArr[m].length; i++) {
      if(this.materialsArr[m][i].name == mat) {
        this.colorsArr[m] = this.materialsArr[m][i].colors.sort((a,b)=>{
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        });
        control.controls[m].controls.color.setValue(this.colorsArr[m][0].name);
      }
    }
  }

  changeLShape() {
    var lshaped = this.iForm.get('lShape').value;
    if(!lshaped) {
      this.iForm.get('lDirection').setValue(null);
      this.iForm.get('lLength').setValue(null);
      this.iForm.get('lWidth').setValue(null);
    }
  }

  cancel() {
    this.iForm.reset();
  }

  calculate(i) {
    const control:any = this.iForm.controls['materials'];
    let cnt = parseInt(control.controls[i].controls.slabCount.value);
    let slab = parseFloat(control.controls[i].controls.slabPrice.value);

    let tots = {
      sub:0,
      tax:0,
      tot:0
    };

    if(cnt <= 0) {
      this.totalsArr[i] = tots;
      return;
    }

    if(slab) {
      tots.sub = slab * cnt;
      tots.tax = tots.sub * .06;
    }



    tots.tot = tots.sub + tots.tax;

    this.totalsArr[i] = tots;
    return;

  }

  getTotals() {
    let ret = 0;
    let ship = 0;
    const shipVal = this.iForm.get('shipping').value;
    ship = parseFloat(shipVal?shipVal:ship);
    this.totalsArr.forEach(function (item) {
      ret  = ret + item.tot;
    });
    return ret+ship;
  }

  cloneItem(i) {
    const control = <FormArray>this.iForm.controls['materials'];
    control.push(this.getMat());
  }

  removeItem(i) {
    const control = <FormArray>this.iForm.controls['materials'];
    control.removeAt(i);
    this.totalsArr.splice(i, 1);
    this.materialsArr.splice(i, 1);
    this.colorsArr.splice(i, 1);

    if(control.controls.length <= 0) {
      control.push(this.getMat());
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/order.component.ts